module.exports = __webpack_public_path__ + "static/media/Rectangle.6abd057b.gif";